<mat-card class="profile-card px-15 pb-20">
  <mat-card-header>
    <mat-card-title>Appointment Detail</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="my-10">
      <mat-divider></mat-divider>
      <div class="my-20"></div>
   
      <div class="my-20 action-button">
           @if(canInitiateEncounter$ | async){
        <a mat-flat-button (click)="encounterService.addEncounter(appointment.id)">
          Initiate encounter
        </a>}

        @if(hasMeetingLink()){
        <button mat-stroked-button style="margin-left: 10px;" (click)="openMeetingLink()">
          <mat-icon>videocam</mat-icon>
          Join meeting
        </button>
        }
      </div>

      <div class="cards-wrapper">

       <!-- PARTICIPANTS -->
<mat-card>
  <mat-card-header>
    <div class="g-just-flex gap-15">
      <div class="header-words">
        <div class="g-just-flex gap-8">
          <mat-icon>people</mat-icon>
          <mat-card-title>Participants</mat-card-title>
        </div>
        <mat-card-subtitle>People involved in this appointment</mat-card-subtitle>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="my-10 mt-20">
      <div class="card-content-details">
        <div class="fields-wrapper g-just-flex gap-15 px-12"
          *ngFor="let participant of appointment.participant">
          <div class="field-group">
            <div class="field-value">
              <!-- resolves reference to display name -->
              <div class="field-value">
                <div class="field-value" [appReferenceDisplay]="participant.actor?.reference" [instantFetchAndReplace]="true"></div>
                <div class="field-sub-value" style="font-size: 12px; color: #7f8c8d; margin-top: 2px;" *ngIf="(participant.actor?.reference | referenceIdentifier | async) as identifier">
                  ID: {{ identifier }}
                </div>
              </div>
            </div>
            <div class="field-title">
              {{ participant.actor?.reference?.split('/')?.[0] || 'Participant' }}
            </div>
          </div>
          <div class="field-group">
            <div class="field-value">
             
              <mat-chip>{{ participant.status | titlecase }}</mat-chip>
            </div>
            <div class="field-title">Status</div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>

        <!-- DATE & TIME -->
        <mat-card>
          <mat-card-header>
            <div class="g-just-flex gap-15">
              <div class="header-words">
                <div class="g-just-flex gap-8">
                  <mat-icon>event</mat-icon>
                  <mat-card-title>Date & Time</mat-card-title>
                </div>
              </div>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="my-10 mt-20">
              <div class="card-content-details">
                <div class="fields-wrapper g-just-flex gap-15">
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.start ? (appointment.start | date:'mediumDate') : 'N/A' }}
                    </div>
                    <div class="field-title">Date</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.start ? (appointment.start | date:'shortTime') : 'N/A' }}
                      -
                      {{ appointment.end ? (appointment.end | date:'shortTime') : 'N/A' }}
                    </div>
                    <div class="field-title">Time Range</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      {{ getDurationMinutes() ? getDurationMinutes() + ' minutes' : 'N/A' }}
                    </div>
                    <div class="field-title">Duration</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      <mat-chip>{{ appointment.status | titlecase }}</mat-chip>
                    </div>
                    <div class="field-title">Status</div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- AGENDA -->
        <mat-card>
          <mat-card-header>
            <div class="g-just-flex gap-15">
              <div class="header-words">
                <div class="g-just-flex gap-8">
                  <mat-icon>adjust</mat-icon>
                  <mat-card-title>Agenda</mat-card-title>
                </div>
                <mat-card-subtitle>The purpose of the appointment</mat-card-subtitle>
              </div>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="my-10 mt-20">
              <div class="card-content-details">
                <div class="fields-wrapper g-just-flex gap-15">
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.serviceType?.[0]?.coding?.[0]?.display || 
                         appointment.serviceType?.[0]?.text || 'N/A' }}
                    </div>
                    <div class="field-title">Requested Service</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.specialty?.[0]?.coding?.[0]?.display || 
                         appointment.specialty?.[0]?.text || 'N/A' }}
                    </div>
                    <div class="field-title">Requested Specialty</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.appointmentType?.coding?.[0]?.display || 
                         appointment.appointmentType?.text || 'N/A' }}
                    </div>
                    <div class="field-title">Type of Appointment</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.priority || 'N/A' }}
                    </div>
                    <div class="field-title">Priority</div>
                  </div>
                  <div class="field-group">
                    <div class="field-value">
                      {{ appointment.reasonCode?.[0]?.coding?.[0]?.display || 
                         appointment.reasonCode?.[0]?.text || 
                         appointment.description || 'N/A' }}
                    </div>
                    <div class="field-title">Reason for Appointment</div>
                  </div>
                  <div class="field-group" *ngIf="appointment.comment">
                    <div class="field-value">{{ appointment.comment }}</div>
                    <div class="field-title">Notes</div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

      </div>
    </div>
  </mat-card-content>
</mat-card>